const TRANSPORT_MODE_LABELS: Record<string, string> = {
  AIR: 'Air',
  SEA: 'Sea',
  EXPRESS: 'Express',
  RAIL: 'Rail',
  TRUCK: 'Truck',
  TRUCK_AIR: 'Truck + Air',
};

export function formatTransportMode(mode?: string | null): string {
  if (!mode) return '—';
  return TRANSPORT_MODE_LABELS[mode] || mode;
}
